import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import {
  ArchivedContent,
  FinalDeleteArchivedContentItemParams
} from '~src/recycleBin/serverApi/types/FinalDeleteArchivedContentItemParams';

export class FinalDeleteArchivedContent extends Request<FinalDeleteArchivedContentItemParams, IResult> {
  constructor(archivedContents: ArchivedContent[]) {
    super('finalDeleteArchivedContent', {contentItems: archivedContents});
  }
}